import getStore from '../store/publishingStore';
import { mutator } from 'satcheljs';
import { initializeCalendarPublishingPermissionStore } from '../actions/calendarPublishing';
import { ObservableMap } from 'mobx';
import PublishedCalendar from '../store/schema/PublishedCalendar';
import CalendarPublishingError from '../store/schema/CalendarPublishingError';

export default mutator(initializeCalendarPublishingPermissionStore, msg => {
    getStore().viewState = {
        isNewPublishPending: false,
        selectedPublishingItemState: null,
        selectedPublishingPermission: '',
        publishedCalendarsMap: new ObservableMap<string, PublishedCalendar>(),
        isInitialLoadPending: false,
        errorState: {
            error: null,
            calendarErrors: new ObservableMap<string, CalendarPublishingError>(),
        },
    };
});
